import asset_risk_messages from 'messages/asset_risk_messages';
import { StaticTableFilter } from 'types/TableFilter';

const riskAnalysisCompletedScopeFilter: StaticTableFilter = {
  isDynamic: false,
  sectionName: asset_risk_messages.completed_scope.label,
  filters: [
    { id: 'latest', name: asset_risk_messages.completed_scope.latest },
    { id: 'all', name: asset_risk_messages.completed_scope.all },
  ],
  isSingleSelect: true,
};

export default riskAnalysisCompletedScopeFilter;
